// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JVf","fullHeight":"JVaj7","btn":"JVa1","slider":"JVh3","hidden":"JVb-"};